
window.addEventListener("scroll", function () {
		const stickyCheckout = document.querySelector(".addToCart-sticky-purchase");

  var elementTarget = document.querySelector(".checkout-btn")?document.querySelector(".checkout-btn"):document.querySelector("#cart-form");
  if (window.scrollY > (elementTarget.offsetTop + elementTarget.offsetHeight)){
		stickyCheckout?.classList?.add("is-visible");
		sameWidthCircles(true)
	} else {
		stickyCheckout?.classList?.remove("is-visible");
		sameWidthCircles(false)
	}
});

const sameWidthCircles = (stickyFooter) => {
	const choices = document.querySelectorAll(".circle-btns");
	const sticky = document.querySelectorAll(".circle-sticky")
	if (choices) {
		let maxWidth = 0;
		for (i = 0; i < choices.length; ++i) {
			maxWidth = Math.max(maxWidth, choices[i].offsetWidth);
		}
		for (i = 0; i < choices.length; ++i) {
			choices[i].style.width = maxWidth + "px";
		}
		
	}
	if (stickyFooter) {
		if (sticky) {
			let maxStickyWidth = 0;
			for (i = 0; i < sticky.length; ++i) {
				maxStickyWidth = Math.max(maxStickyWidth, sticky[i].offsetWidth);
			}
			for (i = 0; i < sticky.length; ++i) {
				sticky[i].style.width = maxStickyWidth + "px";
			}
		}
	}
};
if (Shopify.designMode) {
	document.addEventListener("shopify:section:load", function (event) {
		sameWidthCircles();
	});
	sameWidthCircles();
}
const sameWidthOptions = () => {
	var choices = document.querySelectorAll(".squares");

	var maxWidth = 0;
	for (i = 0; i < choices.length; ++i) {
		maxWidth = Math.max(maxWidth, choices[i].offsetWidth);
	}
	for (i = 0; i < choices.length; ++i) {
		choices[i].style.width = maxWidth + "px";
	}
};

const exit = () => {
	document.querySelector(".addToCart-sticky-purchase").style.display = "none";
};

document.querySelector(".exit-icon")?.addEventListener("click", exit);

if (Shopify.designMode) {
	document.addEventListener("shopify:section:load", function (event) {
		sameWidthOptions();
	});
	sameWidthOptions();
}
